export default __webpack_public_path__ + "static/media/logo-12-lapland-hotels.b4df7126.png";